export default function XML_RSS() {
  return (
    <div>
      <h1>XML_RSS</h1>
      <p>This is the XML_RSS component.</p>
    </div>
  );
}